import { postsSlice } from './postsSlice';
import { combineReducers } from '@reduxjs/toolkit';
import { sessionSlice } from './sessionSlice';

export const rootReducer = combineReducers({
  posts: postsSlice.reducer,
  session: sessionSlice.reducer,
});
export type State = ReturnType<typeof rootReducer>;
